import axios from "../../../../utils/axios-private";

export const getCustomerByID = (id) => {
  const request = {
    id: id,
  };
  return {
    type: "GET_CUSTOMER_BY_ID",
    payload: new Promise((resolve, reject) => {
      const controller = new AbortController();
      const url = `/pelanggan/get`;
      axios
        .post(url, request, { signal: controller.signal })
        .then((response) => {
          resolve({ response });
        })
        .catch((error) => {
          controller.abort();
          reject(error);
        });
    }),
  };
};
